<template>
  <div>
    <vxe-grid
      size="small"
      ref="table"
      cell-class-name="align-top"
      resizable
      auto-resize
      show-footer
      highlight-hover-row
      row-id="checkKeyId"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :footer-method="() => footerData"
      :checkbox-config="{ trigger: 'row', highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div v-if="row.goodsSize">
            <span class="mr-1">SIZE:</span>
            <span>{{ row.goodsSize }}</span>
          </div>
          <div v-if="row.goodsColor || row.goodsColorEn">
            <span class="mr-1">COLOR:</span>
            <span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayMaterialInfoName="{ row }">
        <div class="m-0" style="    text-align: left;">
          <div>{{ row.materialInfo }}</div>
          <div>{{ row.materialInfoEn }}</div>
        </div>
      </template>

      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>
            <span class="mr-1">SKU:</span>
            <span>{{ row.amzSkuNo }}</span>
          </div>

          <div>
            <span>SPU:</span
            ><span style="color: #409EFF">{{ row.amzSpuNo }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayFactory="{ row }">
        <div class="m-0">
          <span>NC：{{ row.ncNo }}</span>
          <br />
          <span>{{ row.scmName }}</span>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { format, round } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    totalData: { type: Object, default: () => {} },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      round: (x, y) => round(x, y),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          if (!Object.keys(this.totalData).includes(t.field)) return '--'
          const val = this.totalData[t.field]
          return val ? format(val) : '0'
        })
      result[1] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    removeCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
  .el-tag--confirm {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
